export const copyToClipBoard = async (e: Event, text?: string) => {
  e.stopPropagation();
  e.preventDefault();
  if (!navigator.clipboard || !text) return;
  await navigator.clipboard.writeText(text);
};

export function clone<T>(obj: any): T {
  if (obj === null || typeof obj !== 'object' || 'isActiveClone' in obj) {
    return obj;
  }

  const temp = obj instanceof Date ? new Date(obj) : obj.constructor();

  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      obj.isActiveClone = null;
      temp[key] = clone(obj[key]);
      delete obj.isActiveClone;
    }
  }

  return temp;
}

export function pluck(obj: { [key: string]: any } = {}, wantedKeys: string[] = []) {
  return wantedKeys.reduce((sanitizedObject, wantedKey) => {
    if (obj[wantedKey] !== undefined) {
      sanitizedObject[wantedKey] = obj[wantedKey];
    }
    return sanitizedObject;
  }, {} as { [key: string]: any });
}
